














































import IQuestion from '@/models/IQuestion'
import IAnswer from '@/models/IAnswer'
import IDraggableParams from '@/models/IDraggableParams'

export interface IDraggableParamsExtend extends IDraggableParams {
  questionId: string
  oldIndexId: string
  newIndexId: string
}

import {Vue, Component, Prop} from 'vue-property-decorator'

import QuestionBox from './QuestionBox.vue'
import draggable from 'vuedraggable'
import PostSignature from '@/components/lfs/Survey/PostSignature.vue';
import Comment from '@/components/lfs/Survey/Comment.vue';


@Component({
  name: 'c-question-box-list',

  components: {
    Comment,
    PostSignature,
    'c-question-box': QuestionBox,
    draggable
  }
})
export default class QuestionBoxList extends Vue {
  // Props
  @Prop() questions!: IQuestion[]

  @Prop({type: Array, default: () => []}) allQuestions!: IQuestion[]

  @Prop({type: Boolean, default: false}) isParent!: boolean

  @Prop() selectedQuestion: string | undefined

  @Prop({type: String, default: null}) parentId!: string | null

  // Data
  drag: boolean = false
  isChanged: boolean = false

  // Computed
  get allIncludeQuestions (): string[] {
    return this.questions.reduce((qacc: string[], q: IQuestion) => {
      const includeQuestions = q.answers.reduce((aacc: string[], q: IAnswer) => {
        if (q.includeQuestions) {
          return [...aacc, ...q.includeQuestions]
        }

        return [...aacc]
      }, [])

      return [...qacc, ...includeQuestions]
    }, [])
      .filter(v => !!v)
  }

  get parentQuestions (): IQuestion[] {
    const parentQs = this.questions.filter(v => !this.allIncludeQuestions.includes(v.id))

    parentQs.sort((a, b) => a.order - b.order)

    return parentQs
  }
  set parentQuestions (questions: IQuestion[]) {
    this.$emit('change-questions', questions)
  }

  // Methods
  getQuestionsByAnswers (question: IQuestion) {
    const includeQuestions = question.answers.reduce((acc: string[], v: IAnswer) => {
      if (v.includeQuestions) {
        return [...acc, ...v.includeQuestions]
      }

      return [...acc]
    }, [])

    return this.allQuestions.filter(v => includeQuestions.includes(v.id))
  }

  handleDrag (params: IDraggableParams) {
    const oldIndexId = params.moved.element.id
    const newIndex = params.moved.oldIndex
    const newIndexId = this.parentQuestions[newIndex].id

    this.$emit('swapQuestions', {oldIndexId, newIndexId})
  }

  changeAnswersOrder (params: IDraggableParamsExtend) {
    this.$emit('changeAnswersOrder', params)
  }

  deleteAnswer (data: {answerId: string, questionId: string}) {
    this.$emit('deleteAnswer', data)
  }
}
